module.exports = __webpack_public_path__ + "media/images/app/colors/colors-multicolor-e80b3148890ce88b0e4acebcc98192b4.webp";